import qualityCourseLayout from "@/layout/qualityCourse/index.vue";

export const teachRoutes = [
    {
        path: "/teach",
        component: qualityCourseLayout,
        children: [
            {
                path: "/teach/index",
                name: "teachIndex",
                component: () => import("@/views/teach/Index.vue"),
                meta: {
                    title: "题库",
                }
            },
            {
                path: "/teach/topic/add",
                name: "addTopic",
                component: () => import("@/components/material/MaterialExamSubjectAdd.vue"),
                meta: {
                    title: "添加试题"
                }
            },
            {
                path: "/teach/topic/edit",
                name: "addTopic",
                component: () => import("@/components/material/MaterialExamSubjectEdit.vue"),
                meta: {
                    title: "编辑试题"
                }
            },
            {
                path: "/teach/paper/build",
                name: "buildPaper",
                component: () => import("@/components/material/examPaper/addExamPaper.vue"),
                meta: {
                    title: "添加试卷"
                }
            },
            {
                path: "/teach/act",
                name: "paperParent",
                component: () => import("@/layout/teach/Layout.vue"),
                children: [
                    {
                        path: "/teach/paper/random",
                        name: "PaperRandom",
                        component: () => import("@/views/teach/RandomPaper.vue"),
                        meta: {
                            title: "随机组卷"
                        }
                    }
                ]
            }, 
            {
                path: "/teach/mark",
                name: "teachMark",
                component: () => import("@/views/teach/MarkIndex.vue"),
                meta: {
                    title: "随堂练习-详情"
                }
            }
        ]
    },
];

